import { createAsyncThunk, createSlice, PayloadAction, Action } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { fetchCount } from './tagAPI';
import { Note, addNotes/*, AddNotesAction*/ } from '../note/noteSlice';

export interface TagState {
  tags: string[];
}

const initialState: TagState = {
  tags: ['idle'],
};

function addNotesReducer(state: TagState, action: Action): TagState {
	return initialState;
}

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk(
  'tags/fetchTags',
  async (amount: number) => {
    const response = await fetchCount(amount);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const tagSlice = createSlice({
  name: 'tag',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    increment: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
    },
    decrement: (state) => {
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    incrementByAmount: (state, action: PayloadAction<number>) => {
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      //.addCase(addNotes, (state, action: PayloadAction<{[key:string]: Note}>) => {
      .addCase(addNotes, (state, action) => {
		  //return state;
		  state = addNotesReducer(state, action);
	  })
      .addCase(incrementAsync.pending, (state) => {
        //state.tags = 'loading';
      })
      .addCase(incrementAsync.fulfilled, (state, action) => {
        //state.tags = 'idle';
        //state.value += action.payload;
      })
      .addCase(incrementAsync.rejected, (state) => {
        //state.status = 'failed';
      });
  },
});

export const { increment, decrement, incrementByAmount } = tagSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectTag = (state: RootState) => state.tag;

//*
// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd =
  (amount: number): AppThunk =>
  (dispatch, getState) => {
    const currentValue = selectTag(getState());
    dispatch(incrementByAmount(amount));
  };
// */
export default tagSlice.reducer;
